jQuery(document).ready(function ($) {

    $("a[href='#']").attr("href", "javascript:void(0)");

    $(".site-navigation-toggle-open").click(function () {
        $('.site-header').toggleClass("menu_active");
        $('body').toggleClass("toggle_menu_active");
        if ($('body').hasClass("toggle_menu_active")) {
            $(this).attr("aria-expanded", "true").attr("aria-label", "Close navigation menu");
        } else {
            $(this).attr("aria-expanded", "false").attr("aria-label", "Open navigation menu");
        }
        if ($('nav.primary-navigation li.menu-item-has-children').hasClass("open")) {
            $('nav.primary-navigation li.menu-item-has-children button.submenu-toggle').removeClass("active");
            $('nav.primary-navigation li.menu-item-has-children').removeClass("open");
            $('nav.primary-navigation li.menu-item-has-children .sub-menu').slideUp();
        }
    });

    $(window).scroll(function () {
        var sticky = $('.site-header'),
            scroll = $(window).scrollTop();

        if (scroll >= 1) sticky.addClass('sticky');
        else sticky.removeClass('sticky');
    });

    $('nav.primary-navigation').find('li.menu-item-has-children > a').after('<button class="submenu-toggle" type="button" aria-expanded="false" aria-haspopup="true" aria-label="Open child items"><svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L6 6L11 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>');
    $('body').on('click', ".site-nav .site-nav-main .primary-navigation .menu-item-has-children > a", function (e) {
        e.preventDefault();
        if ($(this).parent().find(">.sub-menu").is(":hidden")) {
            $(this).parent().siblings().find('button.submenu-toggle').removeClass("active");
            $(this).parent().siblings().find('button.submenu-toggle').attr("aria-label", "Open child items").attr("aria-expanded", "false");
            $(this).parent().siblings().find('> .sub-menu').slideUp();
            $(this).parent().siblings().removeClass('open');
            $(this).parent().find('button.submenu-toggle').addClass("active").attr("aria-expanded", "true").attr("aria-label", "Close child items");
            $(this).parent().find('> .sub-menu').slideDown();
            $(this).parent().addClass("open");
        } else {
            $(this).parent().find('button.submenu-toggle').removeClass("active").attr("aria-expanded", "false").attr("aria-label", "Open child items");
            $(this).parent().find('> .sub-menu').slideUp();
            $(this).parent().removeClass("open");
        }
    });
    $('body').on('click', ".site-nav .site-nav-main .primary-navigation .menu-item-has-children > .submenu-toggle", function (e) {
        e.preventDefault();
        if ($(this).parent().find(">.sub-menu").is(":hidden")) {
            $(this).parent().siblings().find('button.submenu-toggle').removeClass("active");
            $(this).parent().siblings().find('button.submenu-toggle').attr("aria-label", "Open child items").attr("aria-expanded", "false");
            $(this).parent().siblings().find('> .sub-menu').slideUp();
            $(this).parent().siblings().removeClass('open');
            $(this).parent().find('button.submenu-toggle').addClass("active").attr("aria-expanded", "true").attr("aria-label", "Close child items");
            $(this).parent().find('> .sub-menu').slideDown();
            $(this).parent().addClass("open");
        } else {
            $(this).parent().find('button.submenu-toggle').removeClass("active").attr("aria-expanded", "false").attr("aria-label", "Open child items");
            $(this).parent().find('> .sub-menu').slideUp();
            $(this).parent().removeClass("open");
        }
    });

    jQuery(".hero_banner").each(function (index) {
        let slide = jQuery(this).find(".hero_banner_media_item");
        let slider = jQuery(this).find(".hero_banner_media");
        if (jQuery(slide).length > 1) {
            jQuery(slider).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                infinite: true,
                speed: 500,
                fade: true,
                cssEase: "linear",
                autoplay: true,
                autoplaySpeed: 5000,
            });
        }
    });

    jQuery(".newsletter_section .gform_button").detach().appendTo(".newsletter_section .gform_body .gform_fields");
    jQuery(".newsletter_section form .gform_footer ").css("display", "none");

    setTimeout(() => {
        jQuery(".dotdigital-signup-form .ddg-form-group input[type=email]").attr("autocomplete", "email");
        jQuery(".dotdigital-signup-form .ddg-form-group input[type=email]").attr("aria-label", "email");
        jQuery(".dotdigital-signup-form .ddg-form-group input[type=email]").attr("aria-required", "true");
        jQuery(".dotdigital-form-submit button").attr("aria-label", "Subscribe to our newsletter");
    }, 1000);

    jQuery(".autocomplete_first_name .name_first input").attr("autocomplete", "given-name");
    jQuery(".autocomplete_first_name .name_last input").attr("autocomplete", "family-name");
    jQuery(".autocomplete_phone input").attr("autocomplete", "tel");
    jQuery(".autocomplete_email input").attr("autocomplete", "email");
    jQuery(".autocomplete_country input").attr("autocomplete", "country-name");
    jQuery(".autocomplete_city input").attr("autocomplete", "address-level2");

});

jQuery(document).on('gform_page_loaded', function (event, form_id, current_page) {
    jQuery(".newsletter_section .gform_button").detach().appendTo(".newsletter_section .gform_body .gform_fields");
    jQuery(".autocomplete_first_name .name_first input").attr("autocomplete", "given-name");
    jQuery(".autocomplete_first_name .name_last input").attr("autocomplete", "family-name");
    jQuery(".autocomplete_phone input").attr("autocomplete", "tel");
    jQuery(".autocomplete_email input").attr("autocomplete", "email");
    jQuery(".autocomplete_country input").attr("autocomplete", "country-name");
    jQuery(".autocomplete_city input").attr("autocomplete", "address-level2");
});
